module.exports = __webpack_public_path__ + "img/9788993094572.773735a7.jpg";